import { addListener } from '@reduxjs/toolkit';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import ConversionDialog from 'components/Modals/ConversionDialog';
import { redirectToLoginPage } from 'services/api/base/baseApi';
import { locations } from 'services/routes/locations';

const ExpiredSessionModal = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [isModalShown, setIsModalShown] = useState(false);

  const onSubmit = () => {
    navigate(locations.general.login.pathname, {
      state: { from: location },
    });
    setIsModalShown(false);
  };

  useEffect(() => {
    dispatch(
      addListener({
        actionCreator: redirectToLoginPage,
        effect: () => {
          setIsModalShown(true);
        },
      })
    );
  }, [dispatch]);

  if (!isModalShown) {
    return null;
  }

  return (
    <ConversionDialog
      title={t('general:expiredSessionModal:title')}
      description={t('general:expiredSessionModal:title')}
      submitText={t('general:expiredSessionModal:actionText')}
      state={{
        isOpen: true,
        error: null,
        isLoading: false,
      }}
      action={{
        onSubmit,
        onClose: () => null,
        onExited: () => null,
      }}
    />
  );
};

export default ExpiredSessionModal;
